import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import { buildDeactivatePayload } from 'pages/dynamicContents/dynamicContentUtils';

export async function fetchDynamicContentsList(page = 1, filters = {}) {
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('pageSize', String(filters.pageSize || 15));

  if (filters.content_type) {
    params.set('content_type', String(filters.content_type));
  }
  if (filters.target_type) {
    params.set('target_type', String(filters.target_type));
  }
  if (filters.project_id !== undefined && filters.project_id !== '' && filters.project_id != null) {
    params.set('project_id', String(filters.project_id).trim());
  }
  if (filters.status !== undefined && filters.status !== '' && filters.status !== null) {
    params.set('status', String(filters.status));
  }
  const url = `${Config.dynamicContents.list}?${params.toString()}`;
  const res = await callWebService(callTypes.get, '', url);

  if (res?.data?.status === 0) {
    const data = res.data.data || {};
    return {
      contents: data.contents || [],
      pagination: data.pagination || {},
    };
  }

  const message = res?.data?.message || 'Failed to load client dashboard content';
  throw new Error(message);
}

export async function fetchDynamicContentView(id) {
  const url = `${Config.dynamicContents.view}?id=${encodeURIComponent(id)}`;
  const res = await callWebService(callTypes.get, '', url);

  if (res?.data?.status === 0) {
    return res.data.data?.content ?? res.data.data ?? null;
  }

  const message = res?.data?.message || 'Failed to load content details';
  throw new Error(message);
}

export async function updateDynamicContent(payload) {
  const res = await callWebService(callTypes.post, payload, Config.dynamicContents.edit);

  if (res?.data?.status === 0) {
    return res.data;
  }

  const message = res?.data?.message || 'Failed to update content';
  throw new Error(message);
}

export async function deactivateDynamicContent(id) {
  const res = await callWebService(
    callTypes.post,
    buildDeactivatePayload(id),
    Config.dynamicContents.edit
  );

  if (res?.data?.status === 0) {
    return res.data;
  }

  const message = res?.data?.message || 'Failed to deactivate content';
  throw new Error(message);
}
